import React, { useEffect } from 'react'

import CommunityLandingPage from './CommunityLandingPage'
import { ListContainer } from './ListContainer'
import BackgroundColor from './BackgroundColor'

import { AnimatePresence, motion } from 'framer-motion'
import { useStore } from '../../lib/context'
import { observer } from 'mobx-react-lite'
import useCommunityListData from '../../lib/useCommunityListData'

const MotionCommunityLandingPage = motion(CommunityLandingPage)
const MotionListContainer = motion(ListContainer)

const Community = observer(({ data }) => {
  const {
    uiStore: { community__activeTab },
  } = useStore()


  const contributors = data.allContentfulContributor.edges.map((e) => e.node)
  const businesses = data.allContentfulBusiness.edges.map((e) => e.node)
  const collaborators = data.allContentfulCollaborator.edges.map((e) => e.node)
  const resources = data.allContentfulResourceCommunity.edges.map((e) => e.node)

  const categoryData = { contributors, businesses, collaborators, resources }
  useCommunityListData(categoryData)

  const transition = {
    duration: 0.4,
  };
  
  const exitTransition = { delay: 0, duration: 0.2 }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [community__activeTab])


  return (
    <div>
      
      <BackgroundColor />
      <AnimatePresence exitBeforeEnter>
        {community__activeTab === null && (
          <MotionCommunityLandingPage
            key="community"
            initial={{ opacity: 0 }}
            animate={{
              opacity: 1,
            }}
            exit={{
              opacity: 0,
            }}
            transition={{ duration: 0.7 }}
            exitTransition={{ delay: 0, duration: 0.5 }}
            data={data.allContentfulCommunityStatement.edges[0].node}
          />
        )}
        {community__activeTab !== null &&
          community__activeTab.label === 'Business' && (
            <MotionListContainer
              key="Business"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={transition}
              exitTransition={exitTransition}
              data={categoryData.businesses}
              allData={data}
              category={'Business'}
            />
          )}
        {community__activeTab !== null &&
          community__activeTab.label === 'Contributor' && (
            <MotionListContainer
              key="Contributor"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={transition}
              exitTransition={exitTransition}
              data={categoryData.contributors}
              allData={data}
              category={'Contributor'}
            />
          )}
        {community__activeTab !== null &&
          community__activeTab.label === 'Collaborator' && (
            <MotionListContainer
              key="Collaborator"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={transition}
              exitTransition={exitTransition}
              data={categoryData.collaborators}
              allData={data}
              category={'Collaborator'}
            />
          )}
        {community__activeTab !== null &&
          community__activeTab.label === 'Resources' && (
            <MotionListContainer
              key="Resources"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={transition}
              exitTransition={exitTransition}
              data={categoryData.resources}
              allData={data}
              category={'Resources'}
            />
          )}
      </AnimatePresence>

    </div>
  )
})

export default Community
